import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom'; // Mantén solo los componentes necesarios
import Home from './components/Home/home';
import Navbar from './components/Navbar/navbar';
import Register from './components/Users/register';
import Login from './components/Users/login';
import CreateShowForm from './components/Shows/createshowform';
import AdminPanel from './components/AdminPanel/Pages/adminpanel';
import Profile from './components/Users/profile';
import EditShow from './components/AdminPanel/Pages/editevent';
import TicketDetail from './components/Eventdetail/TicketDetail';
import Modal from 'react-modal';
import Generaltribunes from './components/Eventdetail/generaltribune';
import MisCompras from './components/Users/miscompras';
import SuccessPage from './components/Eventdetail/succesbuy';
import Ticketscan from './components/TiketsEscan/tiketscaned';
import GeneralShow from "./components/GeneralShows/generaldetail";
import GeneralZoneForm from './components/GeneralShows/generalzoneform';
import axios from "axios";
import TicketGeneral from './components/GeneralShows/ticketgeneral';
import { PaymentFailed } from './components/Eventdetail/Pagofallido';
import { useStorageAutoClear } from "./components/Utils/storagecleaned";
import Detail from './components/Eventdetail/detail';
import CreateZone from '../src/components/ManagerSeat/createzone';
import { logoutUser } from './components/Redux/Actions/actions'; // Ajusta la ruta según tu proyecto
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import SalesSummaryPage from './components/AdminPanel/Pages/generarResumenVentas';
import ClickProtection from './components/Utils/seguridadapp';

 axios.defaults.baseURL = process.env.REACT_APP_API_URL; 
//axios.defaults.baseURL = process.env.REACT_APP_API_URL2



function App() {
  useStorageAutoClear();
  Modal.setAppElement('#root');
  // const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    document.body.style.overflow = location.pathname === '/' ? 'hidden' : 'visible';
  }, [location.pathname]);

  // Interceptor para agregar token a cada request
  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
          // console.log('🚀 Token enviado en headers:', token);
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (
          error.response &&
          error.response.status === 401 &&
          localStorage.getItem('token')
        ) {
          try {
            // Limpiar token
            localStorage.removeItem('token');
            
            // Limpiar usuario guardado
               localStorage.removeItem('user');
               
            // Limpiar estado global
            dispatch(logoutUser());

            // Mostrar SweetAlert
            await Swal.fire({
              icon: 'warning',
              title: 'Sesión expirada',
              text:
                error.response.data?.message ||
                'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
              confirmButtonText: 'OK',
            });

            // Redirigir al login
            window.location.href = '/login';
          } catch (err) {
            console.error('Error manejando token expirado:', err);
          }
        }
        return Promise.reject(error);
      }
    );

    // Limpiar interceptors al desmontar
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [dispatch]);

  return (
    <>
      <ClickProtection />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/event/:id" element={<Detail />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/createzone"
          element={user?.isAdmin ? <CreateZone /> : <Navigate to="/" />}
        />
        <Route path="/login" element={<Login />} />
        <Route
          path="/create-show"
          element={user?.isAdmin ? <CreateShowForm /> : <Navigate to="/" />}
        />
        <Route path="/event/general/:id" element={<GeneralShow />} />
        <Route path="/profile" element={<Profile />} />
        <Route
          path="/admin/events/edit/:showId"
          element={user?.isAdmin ? <EditShow /> : <Navigate to="/" />}
        />

        <Route
          path="/create/general/zone/:id"
          element={user?.isAdmin ? <GeneralZoneForm /> : <Navigate to="/" />}
        />
        <Route
          path="/resumen-ventas"
          element={
            user && (user.isAdmin || user.cashier)
              ? <SalesSummaryPage />
              : <Navigate to="/" />
          }
        />
        <Route path="/ticket-detail" element={<TicketDetail />} />
        <Route path="/generaltribune" element={<Generaltribunes />} />
        <Route path="/profile/miscompras" element={<MisCompras />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/success/:id" element={<SuccessPage />} />
        <Route path="/general/ticket/success" element={<TicketGeneral />} />
        <Route path="/general/ticket/success/:id" element={<TicketGeneral />} />
        <Route path="/tickets/useQR/:ticketId" element={<Ticketscan />} />
        <Route path="/failure" element={<PaymentFailed />} />
        <Route path="/tickets/test" element={<h1>🚀 RUTA DETECTADA</h1>} />
        <Route path="/admin/*" element={<AdminPanel />} />
      </Routes>
    </>
  );
}




export default App;

